import { Steps } from "@chakra-ui/react";

import { LuCheck } from "react-icons/lu";

import { STEPS } from "@features/services/travel/types";

const TravelStepList = () => (
  <Steps.List>
    {STEPS.map((s, index) => (
      <Steps.Item key={index} index={index} title={s.title}>
        <Steps.Trigger cursor="pointer">
          <Steps.Indicator
            borderColor="border.dark"
            _current={{ borderColor: "fg", color: "fg" }}
          >
            <Steps.Status
              complete={<LuCheck />}
              incomplete={String(index + 1)}
            />
          </Steps.Indicator>
          <Steps.Title display={{ base: "none", md: "block" }} fontSize="sm">
            {s.title}
          </Steps.Title>
        </Steps.Trigger>
        <Steps.Separator bg="border.dark" />
      </Steps.Item>
    ))}
  </Steps.List>
);

export default TravelStepList;
